// material-ui
import { Grid } from '@material-ui/core';
import React from 'react';

// api
import { EAllowStatus, ResourceActiveEnabled } from '~/src/dash/api/console-api';
import {
  ENetworkRole,
  INetwork,
  INetworkChannel,
  INetworkInVideoUnit,
  INetworkPublisherMap,
  INetworkTracker,
  NetworkDemandSourceType,
  NetworkStreamType,
} from '~/src/dash/api/network';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
// utils
import { makeid } from '~/src/dash/utils/makeid';
// views
import { NetworkSettingsView } from '~/src/dash/views/networks/network-settings-view';

interface IProps extends IReduxActionProps, ISessionStateProps, IUserStateProps, IHistoryProps {}

const createEmptyNetworkChannel = (overwrite: object = {}): INetworkChannel =>
  ({
    ID: 0,
    Name: 'inventory_split_' + makeid(),
    AdURL: '',
    AppBundleOverride: '',
    DemandSourceType: NetworkDemandSourceType.TYPE_PUBLICA,
    SiteID: 0,
    ...overwrite,
  }) as INetworkChannel;

export const NetworkSettingsNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps> {
    render() {
      return (
        <Grid>
          <NetworkSettingsView
            isClone={false}
            // NOTE: New fields added to a network will have to be added here
            // IDs are set to 0 which allows new IDs to be created by API
            currentNetwork={
              {
                ID: 0,
                Name: '',
                UUID: '',
                StreamURL: '',
                EndpointURLParams: '',
                // New networks require at least 1 network channel, so add a default one
                Channels: [createEmptyNetworkChannel()],
                NetworkTrackers: [] as INetworkTracker[],
                NetworkInVideoUnits: [] as INetworkInVideoUnit[],
                Active: ResourceActiveEnabled,
                StreamType: NetworkStreamType.TYPE_VOD,
                TargetingSCTECueIDs: '',
                TargetingSCTECueIDsIsAllowed: EAllowStatus.ALLOW,
                // initialize network publisher map with new map and current pub as owner
                NetworkPublisherMaps: [
                  {
                    ID: 0,
                    PublisherID: parseInt(this.props.session.publisher.ID, 10),
                    NetworkID: 0,
                    NetworkPublisherRole: ENetworkRole.ROLE_OWNER,
                  },
                ] as INetworkPublisherMap[],
              } as INetwork
            }
          />
        </Grid>
      );
    }
  },
);
